<!--
 * @Author: 01399133
 * @Date: 2021-06-07 17:40:02
 * @LastEditors: 01387189
 * @LastEditTime: 2021-07-22 10:44:08
 * @Description: file content
-->
<template>
  <a-config-provider :locale="locale">
    <div id="app" class="AppPage">
      <app-header v-if="showHeader" :mobile="mobile" />
      <div :class="{ main: showHeader }">
        <router-view />
      </div>
      <app-footer v-if="showFooter" />
    </div>
  </a-config-provider>
</template>

<script>
import { mapState } from "vuex";
import AppHeader from "@/components/header/AppHeader";
import AppFooter from "@/components/footer/AppFooter";
import zhCN from "ant-design-vue/lib/locale-provider/zh_CN";
import { getUserMobile } from "@/api/user.js";
import { queryUrlVal } from "@/libs/esg-acsp-core-vue-lib/utils/Tools";
export default {
  components: {
    AppHeader,
    AppFooter,
  },
  name: "App",
  data() {
    return {
      locale: zhCN,
      showHeader: false,
      showFooter: false,
    };
  },
  computed: {
    ...mapState("storeVuex", ["mobile"]),
  },
  watch: {
    $route(to, from) {
      // 对路由变化作出响应...
      if (to.path === "/login") {
        this.showHeader = false;
        this.showFooter = false;
      } else {
        this.showHeader = true;
        this.showFooter = true;
      }
    },
  },
  mounted() {
    // IframeUtil.init({ name: "STORE" });
    this.showHeader = this.$route.path !== "/login";
    this.showFooter = this.$route.path !== "/login";
    // 路由上有jwt参数说明从B端统一账号过来，没有登录不调用查信息接口
    if (queryUrlVal("jwt")) return;
    this.getUserInfo();
  },
  methods: {
    async getUserInfo() {
      try {
        let { success, obj } = await getUserMobile();
        if (success) {
          this.$store.dispatch("storeVuex/updateMobile", obj);
        }
      } catch (error) {}
    },
  },
};
</script>

<style lang="less">
@import "./styles/common.less";
@import "./styles/anim.less";
@import "./libs/esg-acsp-core-vue-lib/style/flex.css";
@import "./libs/esg-acsp-core-vue-lib/style/reset.css";

#app {
  width: 100%;
  min-width: 1240px;
  overflow: hidden;
  .main {
    margin-top: 56px;
  }
}
</style>
